import { IsNotEmpty, IsUUID, IsOptional } from 'class-validator';

export class GenerateDocumentDto {
  @IsNotEmpty()
  @IsUUID()
  templateId: string;

  @IsOptional()
  @IsUUID()
  fileId?: string;

  attributes: { key: string; value: string }[];
}
